<template>
  <div class="chart-card">
    <div class="chart-header">
      <h3 class="chart-title">{{ title }}</h3>
      <slot name="header-actions"></slot>
    </div>
    <div class="chart-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartCard',

  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.chart-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f3f4f6;
}

.chart-title {
  margin: 0;
  color: #1a202c;
  font-size: 18px;
  font-weight: 600;
}

.chart-body {
  flex: 1;
  min-height: 300px;
}
</style>